// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2imJu","right":"styles_right__3SWgu"};